module.exports = __webpack_public_path__ + "img/aurora-rectangle-front-angle.56d21e75.png";